import React from 'react'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import { useAppSelector } from 'redux/Hook'
import SentimentSummary from './SentimentSummary'

const StyledBox = styled(Box)`
  width: 100%;
  max-width: 75rem;
  margin: 0 auto;

  @media (max-width: 700px) {
    max-width: 100%;
  }
`

const SummarisedResults = () => {
  const { t } = useTranslation()
  const { summarisedResults } =
    useAppSelector((state) => state.textAnalysis.main) || {}
  const sentimentSummary = summarisedResults?.sentimentSummary || {}

  return (
    <Stack
      spacing={2.5}
      width={1}
      height={1}
      data-testid="ta-summarised-results"
      direction={{ xs: 'column' }}
      aria-labelledby="summarized-results-heading"
    >
      <StyledBox data-testid="ta-sentiment-summary" tabIndex={0}>
        <SentimentSummary
          title={t('textAnalysis.summarisedResults.sentimentSummary')}
          sentiment={sentimentSummary}
        />
      </StyledBox>
    </Stack>
  )
}

export default SummarisedResults
